<template>
    <ListeBonCommandeFournisseur/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ListeBonCommandeFournisseur from "@/components/GesCom/BonCommandeFournisseur/ListeBonCommandeFournisseur.vue";
    export default defineComponent({
      name: "ListeBonCommandeFournisseurPage",
      components: {
        ListeBonCommandeFournisseur,
      },
    });
  </script>